import {
   CurrentAccountPersonalCertificateSetCommand,
   InvalidCertificateContainerFault,
   InvalidCertificateContainerPasswordFault,
   PersonalCertificateMetadata,
} from '@dreryk/egabinet-personal-certificate-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { AuthenticationCommonFault, useAuthenticationCommonFaultHandlerMap } from '@dreryk/egabinet-security-frontend';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { CertificateFault, useCertificateFaultHandlerMap } from '~libs.desktop.shared.account';

import { personnelTranslationKeys } from '../../../translations';
import { useCertificateQuery } from '../certificate.hooks';
import { CertificateFormBean } from '../certificate.types';

type UseCurrentAccountCertificateSetCommandOptions = {
   onSuccess: VoidFunction;
   onLoginFault: VoidFunction;
   onCertificateNoLongerValid: VoidFunction;
   onInvalidCertificateContainerFault: VoidFunction;
   onInvalidCertificateContainerPasswordFault: VoidFunction;
};

export const useCurrentAccountCertificateSetCommand = (
   options: UseCurrentAccountCertificateSetCommandOptions
): UseCqrsCommandResult<
   PersonalCertificateMetadata,
   CertificateFormBean,
   | AuthenticationCommonFault
   | CertificateFault
   | InvalidCertificateContainerFault
   | InvalidCertificateContainerPasswordFault
> => {
   const { setData: setCertificate } = useCertificateQuery();

   return useCqrsCommand(
      (parameters: CertificateFormBean) => {
         const command = new CurrentAccountPersonalCertificateSetCommand();
         command.certificateContainer = parameters.certificateFileDescriptor!;
         command.containerPassword = parameters.certificatePassword!;
         command.userPassword = parameters.userPassword!;
         return command;
      },
      {
         onSuccess: (result) => {
            setCertificate(result);
            dispatchSnackbarPositiveEvent(personnelTranslationKeys.myAccount.certificate.updateCertificateSuccess);
            options.onSuccess();
         },
         onFault: {
            ...useAuthenticationCommonFaultHandlerMap({
               onLoginFault: options.onLoginFault,
            }),
            ...useCertificateFaultHandlerMap({
               onCertificateNoLongerValid: options.onCertificateNoLongerValid,
            }),
            'egabinet-personal-certificate-frontend-api:InvalidCertificateContainerFault': () =>
               options.onInvalidCertificateContainerFault(),
            'egabinet-personal-certificate-frontend-api:InvalidCertificateContainerPasswordFault': () =>
               options.onInvalidCertificateContainerPasswordFault(),
         },
         onUnexpectedError: () =>
            dispatchSnackbarNegativeEvent(
               personnelTranslationKeys.myAccount.certificate.errorOccurredWhileEnteringCertificate
            ),
      }
   );
};
